import {ChecklistRecipient, ChecklistSummary, Contact} from '../api/dtos/dtos';
import * as React from 'react';
import {Button, Icon} from 'antd';
import locales from "../locales";
import SectionHeaderFormItem from "../common/form-items/SectionHeaderFormItem";
import StaticFormItem from "../common/form-items/StaticFormItem";
import FormItem from "antd/lib/form/FormItem";
import * as formUtils from "../utils/form-utils";
import {LoadingOverlayHandler,} from "../app/ApplicationContext";
import {formatDateTime} from "../utils/date-utils";
import {
  findAcceptedAtDate,
  findAcceptedBy,
  findAllIgnored, findAllNotIgnored,
  findSendoutAtDate,
  findSendoutRecipients,
  findWithAllRequiredAttachments
} from "./dtos";
import EmailContactTag from "../common/EmailContactTag";

interface Props {
  summary: ChecklistSummary;
  onSendoutChecklists: () => void;
  style?: React.CSSProperties;
  rentalDeleted?: boolean;
}

interface State {
  recipientContacts: Contact[];
}


class ChecklistSummaryComponent extends React.Component<Props, State> {
  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: Props) {
    super(props);
    this.state = {
      recipientContacts: [],
    }
  }

  public shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
    return nextProps !== this.props;
  }

  public render(): React.ReactNode {
    const {style, summary} = this.props;

    const sum = this.getSumChecklistLength();
    const filled = this.getFilledChecklistLength();
    const missing = sum - filled;

    const ratio = (
      sum / filled === 1 ?
        `${sum} / ${filled} db`
        :
        <>
          {`${sum} / ${filled} db `}<Icon type="warning" theme="filled" style={{color: "orange"}}/>
        </>
    );

    const sendout = findSendoutAtDate(summary);
    const recipients = findSendoutRecipients(summary);

    return (
      <>
        {sum > 0 &&
            <div style={{...style, lineHeight: 1.5}}>
                <SectionHeaderFormItem title={locales.checklists} style={{marginTop: 48}} />
                <StaticFormItem
                    style={{marginBottom: 8}}
                    label={locales.checklist_ratio}
                    initialValue={ratio}
                />
                <StaticFormItem
                    style={{marginBottom: 8}}
                    label={locales.checklist_sent_out}
                    initialValue={sendout ? formatDateTime(sendout) : '-'}
                />
              {recipients &&
                  <StaticFormItem
                      style={{marginBottom: 8,}}
                      label={locales.checklist_recipients}
                      initialValue={this.renderRecipientTags(recipients)}
                  />
              }
                <StaticFormItem
                    style={{marginBottom: 8}}
                    label={locales.checklist_accepted_at}
                    initialValue={this.renderAccepted()}
                />


                <FormItem {...formUtils.tailFormItemLayout}>
                    <Button type={"primary"} disabled={missing !== 0 || this.props.rentalDeleted}
                            onClick={this.props.onSendoutChecklists}>
                      {findAcceptedAtDate(summary) ? locales.checklist_show_accepted : locales.checklist_send}
                    </Button>
                </FormItem>
            </div>
        }
      </>
    );
  }

  private getSumChecklistLength(): number {
    const {summary} = this.props;
    return summary.requiredCount - (findAllIgnored(summary)?.length ?? 0);
  }

  private getFilledChecklistLength(): number {
    const {summary} = this.props;
    const notIngoredChecklists = findAllNotIgnored(summary);
    return findWithAllRequiredAttachments(notIngoredChecklists)?.length ?? 0;
  }


  private renderRecipientTags(recipients: ChecklistRecipient[]) {
    return (
      <div style={{lineHeight: 2}}>
        {recipients.map((c) => <EmailContactTag key={c.contact.id} contact={c.contact} link={c.link}/>)}
      </div>
    );
  }

  private renderAccepted() {
    const {summary} = this.props;
    const accepted = findAcceptedAtDate(summary);
    const acceptedBy = findAcceptedBy(summary);

    if (!accepted) {
      return '-';
    }

    return (
      <>
        {formatDateTime(accepted)} - {acceptedBy && <EmailContactTag contact={acceptedBy}/>}
      </>
    );
  }
}

export default ChecklistSummaryComponent;



// WEBPACK FOOTER //
// ./src/checklist/ChecklistSummaryComponent.tsx